import { Link } from "react-router-dom";
import { X, Sparkles, Zap, ArrowRight } from "lucide-react";

/**
 * Soft upsell shown when a Starter merchant hits a locked feature.
 * Backend returns 402 with detail = { error, tier, cap, message, upsell_url }.
 */
export default function UpsellModal({ open, detail, onClose }) {
  if (!open || !detail) return null;
  const isCap = detail.error === "campaign_cap_reached";

  return (
    <div className="fixed inset-0 z-[85] flex items-center justify-center p-4" data-testid="upsell-modal">
      <div className="absolute inset-0 bg-slate-900/50 backdrop-blur-md" onClick={onClose} />
      <div className="glass-strong rounded-[28px] max-w-md w-full p-8 relative z-10 fade-up">
        <button onClick={onClose} className="absolute top-4 right-4 p-1.5 rounded-full hover:bg-white/70 text-slate-500" aria-label="Close">
          <X className="w-4 h-4" />
        </button>
        <div className="pf-chip pf-chip-lav w-fit"><Zap className="w-3 h-3" /> Unlock more</div>
        <h2 className="font-display text-3xl font-medium tracking-tight mt-3 text-slate-900 leading-tight">
          {isCap ? "You've hit your plan limit" : "Growth-tier feature"}
        </h2>
        <p className="text-sm text-slate-600 mt-3 leading-relaxed">
          {detail.message}
        </p>

        <div className="mt-6 space-y-2">
          {["Unlimited campaigns", "Affiliate platform + tracking links", "Cashback wallet for shoppers", "AI copy nudges", "Webhooks + REST API"].map((f) => (
            <div key={f} className="flex items-start gap-2 text-sm text-slate-700">
              <Sparkles className="w-3.5 h-3.5 text-cyan-600 mt-0.5" /> {f}
            </div>
          ))}
        </div>

        <div className="mt-7 grid grid-cols-2 gap-3">
          <Link
            to={detail.upsell_url || "/merchant/billing"}
            className="pf-btn-primary py-3 rounded-full font-semibold text-sm text-center inline-flex items-center justify-center gap-1"
            data-testid="upsell-cta"
            onClick={onClose}
          >
            See plans <ArrowRight className="w-4 h-4" />
          </Link>
          <button onClick={onClose} className="pf-btn-glass py-3 rounded-full font-semibold text-sm" data-testid="upsell-dismiss">
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}
